const YANDEX_LANG = {
	RU: 'ru_RU',
	EN: 'en_US',
	EN_RU: 'en_RU',
};

const LANG = {
	RU: 'ru',
	EN: 'en',
};

export {
	YANDEX_LANG,
	LANG,
};
